import React from "react";
import PropTypes from "prop-types";

import { KeyPressNumbers, PortaalTeksten } from "../../constants/DomainConstants";
import SearchBlock from "../common/SearchBlock";

const GeneesmiddelFilterForm = (props) => {
    const {
        portaalTeksten,
        geneesmiddelNaamFromFilter,
        onChangeFilter,
        filterModel,
        filterItems,
        onSearchTextChange,
        onSelectSearchOption,
        onSearch,
        onKeyUp,
        onChangeSelectOption
    } = props;

    const handleOnSearch = (pageSize, naam, sortAscending) => {
        return function (event) {
            if (!event.which || event.which === KeyPressNumbers.ENTER ) {
                onSearch(event, 1, pageSize, naam, sortAscending);
            }
        };
    };

    const subtitelTekstObject = portaalTeksten ? portaalTeksten.find(t => t.label.naam === PortaalTeksten.BEHEER_GENEESMIDDELEN_SUBTITEL) : null;
    const subtitelTekst = subtitelTekstObject ? subtitelTekstObject.label.portaalTekst : "";
    const titelTekstObject = portaalTeksten ? portaalTeksten.find(t => t.label.naam === PortaalTeksten.BEHEER_GENEESMIDDELEN_TITEL) : null;
    const titelTekst = titelTekstObject ? titelTekstObject.label.portaalTekst : "";

    return (
        <SearchBlock
            titelTekst={titelTekst}
            subtitelTekst={subtitelTekst}
            placeholder="Naam"
            maxlength={200}
            name="geneesmiddelNaamFromFilter"
            value={geneesmiddelNaamFromFilter}
            onChangeFilter={onChangeFilter}
            items={filterItems}
            onSelect={onSelectSearchOption}
            onTextChange={onSearchTextChange}
            onSearch={handleOnSearch(filterModel.pageSize, geneesmiddelNaamFromFilter, filterModel.sortAscending)}
            onKeyUp={onKeyUp}
            onChangeSelectOption={onChangeSelectOption}
        />);
};

GeneesmiddelFilterForm.propTypes = {
    portaalTeksten: PropTypes.array,
    geneesmiddelNaamFromFilter: PropTypes.string,
    onChangeFilter: PropTypes.func,
    filterModel: PropTypes.object,
    filterItems: PropTypes.array,
    onSearchTextChange: PropTypes.func,
    onSelectSearchOption: PropTypes.func,
    onSearch: PropTypes.func,
    onKeyUp: PropTypes.func,
    onChangeSelectOption: PropTypes.func
};

export default GeneesmiddelFilterForm;